import { CellTable } from "@/atoms"
import {
  TableCard,
  type TableCardProps
} from "@/organisms/Drawers/components/TriageDrawer/components/KaiFix/components/TableCard"
import { HEADING_KEY } from "../../helpers"
import { ValueCell } from "../ValueCell"

import styles from "./TableDetailsAdr.module.scss"

import type { DefaultRecord } from "."

export const TableDetailsAdr = <R extends DefaultRecord>(
  props: Pick<TableCardProps<any>, "dataSource">
) => {
  return (
    <TableCard<R>
      bordered
      secondary
      className={styles.table}
      showHeader={false}
      columns={[
        {
          dataIndex: "label",
          width: "185px",
          render: CellTable,
          onCell: (item) => {
            if (item.key.startsWith(HEADING_KEY))
              return {
                colSpan: 2,
                style: { backgroundColor: "var(--neutral-1-color)" }
              }

            return {}
          }
        },
        {
          dataIndex: "value",
          render: ValueCell,
          onCell: (item) => {
            if (item.key.startsWith(HEADING_KEY)) return { colSpan: 0 }

            return {}
          }
        }
      ]}
      {...props}
    />
  )
}
